import { atomWithStorage } from "jotai/utils";

export const themeAtom = atomWithStorage("themeMode", "dark");
